import type { ImageRotation, ListingImage } from '@/types';

export type RotationDirection = 'left' | 'right';

export const normalizeRotation = (degrees?: number | null): ImageRotation => {
  const quarterTurns = Math.round((degrees ?? 0) / 90);
  return ((((quarterTurns % 4) + 4) % 4) * 90) as ImageRotation;
};

export const rotateImage = (
  current: number | null | undefined,
  direction: RotationDirection,
): ImageRotation =>
  normalizeRotation(normalizeRotation(current) + (direction === 'right' ? 90 : -90));

export const isQuarterTurn = (rotation?: number | null) => normalizeRotation(rotation) % 180 !== 0;

export const getListingImageId = ({ id, url }: ListingImage): string | undefined =>
  id || url.split('/').pop()?.split('.')[0] || undefined;

export const getLocationImages = (
  location?: { images?: ListingImage[]; image_urls?: string[] } | null,
): ListingImage[] => location?.images ?? (location?.image_urls ?? []).map((url) => ({ url }));
